import * as THREE from 'three';
import Object2D from '../core/Object2D';

export class Square extends Object2D {
    x: number;

    y: number;

    w: number;

    h: number;

    position: THREE.Vector2[];

    constructor(x: number, y: number, w: number, h: number) {
      super();
      this.type = 'Square';
      this.x = x;
      this.y = y;
      this.w = w;
      this.h = h;

      this.position = [];
      this.buildPlane();
    }

    buildPlane() {
      this.position.push(new THREE.Vector2(this.x - this.w / 2, this.y - this.h / 2));
      this.position.push(new THREE.Vector2(this.x - this.w / 2, this.y + this.h / 2));
      this.position.push(new THREE.Vector2(this.x + this.w / 2, this.y + this.h / 2));
      this.position.push(new THREE.Vector2(this.x + this.w / 2, this.y - this.h / 2));
    }
}
